import React from 'react';
import { motion } from 'framer-motion';

const OnboardingStepUsername = ({
  profile,
  onChange,
  onNext,
  onBack,
  usernameExists,
  checkingUsername
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!usernameExists && profile.username.trim() && profile.name.trim()) {
      onNext();
    }
  };

  const canContinue = profile.name.trim() && profile.username.trim() && !usernameExists && !checkingUsername;

  return (
    <div>
      <div className="mb-10">
        <h2 className="text-[1.75rem] sm:text-[2rem] font-light tracking-tight text-gray-900 mb-2">
          What should we call you?
        </h2>
        <p className="text-[15px] text-gray-400">
          This will appear on your public profile.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-[13px] text-gray-500 mb-2">
            Full name
          </label>
          <input
            type="text"
            value={profile.name}
            onChange={(e) => onChange('name', e.target.value)}
            className="w-full px-4 py-3.5 bg-white border border-gray-200 rounded-xl text-gray-900 text-[15px] placeholder-gray-300 focus:outline-none focus:border-[#f97316] focus:ring-1 focus:ring-[#f97316]/20 transition-all"
            placeholder="Jane Smith"
            required
          />
        </div>

        <div>
          <label className="block text-[13px] text-gray-500 mb-2">
            Username
          </label>
          <input
            type="text"
            value={profile.username}
            onChange={(e) => onChange('username', e.target.value.toLowerCase().replace(/[^a-z0-9._-]/g, ''))}
            className={`w-full px-4 py-3.5 bg-white border rounded-xl text-gray-900 text-[15px] placeholder-gray-300 focus:outline-none focus:ring-1 transition-all ${
              usernameExists
                ? 'border-red-300 focus:border-red-400 focus:ring-red-100'
                : profile.username && !checkingUsername
                  ? 'border-green-300 focus:border-green-400 focus:ring-green-100'
                  : 'border-gray-200 focus:border-[#f97316] focus:ring-[#f97316]/20'
            }`}
            placeholder="janesmith"
            required
          />

          {/* Status text */}
          <div className="mt-2 h-5">
            {checkingUsername && (
              <p className="text-[13px] text-gray-400">Checking availability...</p>
            )}
            {!checkingUsername && usernameExists && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="text-[13px] text-red-500"
              >
                That username is taken. Try another.
              </motion.p>
            )}
            {!checkingUsername && profile.username && !usernameExists && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="text-[13px] text-gray-400"
              >
                klorah.com/profile/<span className="text-gray-600">{profile.username}</span>
              </motion.p>
            )}
          </div>
        </div>

        <div className="flex items-center justify-between pt-6">
          <button
            type="button"
            onClick={onBack}
            className="text-[14px] text-gray-400 hover:text-gray-600 transition-colors"
          >
            Back
          </button>
          <button
            type="submit"
            disabled={!canContinue}
            className="px-8 py-3 bg-[#f97316] hover:bg-[#ea580c] text-white text-[14px] font-medium rounded-xl transition-colors disabled:opacity-30 disabled:hover:bg-[#f97316]"
          >
            Continue
          </button>
        </div>
      </form>
    </div>
  );
};

export default OnboardingStepUsername;
